import axios from "api/axios.js";
import { axiosPrivate } from "api/axios";

let isMounted = true;
const controller = new AbortController();
const getArticleURL = "/articles/get-article";

export async function getArticle(id) {
  try {
    const response = await axios.get(`${getArticleURL}/${id}`, {
      signal: controller.signal,
    });
    return response;
  } catch (err) {
    console.error(err);
  }
  return () => {
    isMounted = false;
    controller.abort();
  };
}
